import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import Grid from '@material-ui/core/Grid';
import GetAppIcon from '@material-ui/icons/GetApp';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';


import CandidatoService from '../../services/Candidato';
import DocumentoService from '../../services/Documento';
import EnumService from '../../services/Enum';
import { errors } from '../../services/API';

import { patternEnum } from '../../variables/Enums/Enum';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Table from '../../components/Table/Table';
import Toast from '../../components/Toast/Toast';
import {
  verifyPagingAndSorting,
  PAGE,
  SIZE,
  ASC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '../../components/Table/Utils';

import DocumentoFilter from '../../forms/Documento/DocumentoFilter';
import {
  DialogRemove as DialogRemoverDocumento
} from '../../forms/Dialog/DialogRemove';
import DialogTratamentoDocumento from './DialogTratamentoDocumento';
import DialogTratamentoFilaDocumentos from './DialogTratamentoFilaDocumentos';
import { ButtonsTratamentoListaDocumentos } from './DialogTratamentoFilaDocumentos';

import { makeStyles } from '@material-ui/core/styles';

import { verifyPersistence, removePagingAndSorting } from '../../helper/PaginationHelper';
import { download } from '../../helper/FileHelper';

import { isAdministradorOuCentral } from '../../security/AuthorizedFunction';

import { Layout } from '../../layouts/private/Private';
import { isInscricoesAbertas } from '../../helper/ContextHelper';
import { patternNome } from '../Candidato/Candidato';

export const useStyles = makeStyles(theme => ({
  body: {
    margin: theme.spacing(3, 0),
  },
}));

export class Documento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: PAGE,
      size: SIZE,
      totalElements: TOTAL_ELEMENTS,
      totalPages: TOTAL_PAGES,
      sort: [{ orderBy: 'criacaoAuditInfo.dataCriacao', order: ASC }],
      defaultOrderBy: 'criacaoAuditInfo.dataCriacao',
      filtered: false,
      filters: [],
      documentos: [],
      totalDocumentosATratar: 0,
      totalDocumentosEmTratamento: 0,
      loading: true,
      sendToSchools: [],
      loadingButtonSave: false,
      optionsTiposDocumento: [],
      refreshFilaTratamento: 0,
      loadingFilaTratamento: false,
      loadingLimparFilaTratamento: false,
    }

    this.state = verifyPersistence(this.state, this.props.location);
  }

  // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
  setToast = t => this.Toast = t;
  setDocumentoFilter = f => this.DocumentoFilter = f;
  setDialogRemoverDocumento = r => this.DialogRemoverDocumento = r;
  setDialogTratamentoDocumento = d => this.DialogTratamentoDocumento = d;
  setDialogTratamentoFilaDocumentos = d => this.DialogTratamentoFilaDocumentos = d;

  // LABELS
  labelSemPermissao = "Você não tem permissão para fazer isso";

  isPodeExcluir = (id) => {
    const documento = this.state.documentos.find(c => c.id === id);
    return documento.validacao.aguardando ? true : false;
  }

  labelVer = id => isAdministradorOuCentral() ? "Baixar Documento" : this.labelSemPermissao;
  labelTratar = id => isAdministradorOuCentral() ? "Realizar Tratamento de Documento" : this.labelSemPermissao;
  labelExcluir = id => isAdministradorOuCentral() ? "Excluir Documento" : this.labelSemPermissao;

  handleVerClick = id => {
    const documento = this.state.documentos.find(d => d.id === id);

    this.Toast.setState({
      message: {
        message: "Em instantes o download iniciará automaticamente",
        type: "info",
        open: true
      }
    });

    CandidatoService.downloadDocumento(documento.candidato.id, documento.id)
      .then(res => download(res))
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        });
      });
  }

  handleTratarClick = id => this.DialogTratamentoDocumento.openModal(this.state.documentos.find(d => d.id === id));

  handleExcluir = id => {
    const documento = this.state.documentos.find(d => d.id === id);
    this.DialogRemoverDocumento.setState({
      dialog: {
        open: true,
        title: `Deseja Remover o Documento do Candidato ${documento.candidato.nome} ?`,
        text: `O Documento ${documento.tipo.nome} será removido do Candidato ${documento.candidato.nome} (${documento.candidato.codigo}) e não poderá ser mais recuperado. Deseja confirmar essa remoção ?`,
        id: id,
        loading: false,
      }
    });
  }

  handleRemoverDocumentoConfirm = (id) => {
    this.DialogRemoverDocumento.loading();

    const documento = this.state.documentos.find(d => d.id === id);

    CandidatoService.removerDocumento(documento.candidato.id, documento.id)
      .then(res => {
        this.Toast.setState({
          message: {
            message: "O Documento foi Excluído com Sucesso.",
            type: 'success',
            open: true
          }
        })
      })
      .catch(error => {
        const e = errors(error);
        const erros = error.response.data.mensagens !== undefined && error.response.data.mensagens.length > 0 ? `${error.response.data.mensagens.map(mensagen => mensagen).join(" ")}` : "";
        
        this.Toast.setState({
          message: {
            message: `Ocorreu um Problema ao Excluir o Documento. ${erros}`,
            type: e.type,
            open: true
          }
        })
      })
      .finally(() => {
        this.DialogRemoverDocumento.close();
        this.loadData();
      });
  }

  handleTratarFilaDocumentos = () => {
    this.setState({ loadingFilaTratamento: true });
    this.DialogTratamentoFilaDocumentos.openModal();
  }

  handleLimparFilaTratamento = () => {
    this.setState({ loadingLimparFilaTratamento: true, });

    DocumentoService.clean()
      .then(() => {
        this.Toast.setState({
          message: {
            message: "Fila limpa com sucesso",
            type: "success",
            open: true
          }
        });

        this.loadData();

      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  loadData = async () => {
    this.props.loadPeriodos();

    let filters = verifyPagingAndSorting(this.state);

    this.setState({
      filters: [...filters],
      filtered: true,
      loading: true
    });

    const tiposDocumento = await EnumService.listarTiposDocumento().then(res => res.data);
    const statusValidacao = await EnumService.listarStatusValidacao().then(res => res.data);
    this.setState({
      ...this.state,
      optionsTiposDocumento: [...tiposDocumento.map(tp => { return { label: tp.nome, value: tp.id }; })],
      optionsStatusValidacao: [...statusValidacao],
    });

    await DocumentoService.filters(filters)
      .then(res => {
        if (res.data.content) {
          this.setState(prev => ({
            documentos: [...res.data.content],
            totalDocumentosATratar: res.data.content.filter(d => d.validacao.aguardando).length,
            totalDocumentosEmTratamento: res.data.content.filter(d => !d.validacao.valido && !d.validacao.invalido && !d.validacao.aguardando).length,
            page: res.data.number,
            size: res.data.size,
            totalElements: res.data.totalElements,
            totalPages: res.data.totalPages,
            loading: false,
            refreshFilaTratamento: prev.refreshFilaTratamento + 1,
            loadingLimparFilaTratamento: false,
          }));

          this.DocumentoFilter.handleFilterPersistence(filters);
        } else {
          this.setState({
            documento: [],
            page: PAGE,
            size: SIZE,
            totalElements: TOTAL_ELEMENTS,
            totalPages: TOTAL_PAGES,
            loading: false,
          });
        }
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })

        this.setState({ loading: false });
      })
  }

  // FILTROS
  filterData = (filters, isActive = true) => this.setState({ filtered: isActive, filters: [...removePagingAndSorting(filters)] }, () => this.loadData());

  // PÁGINA
  handlePage = page => this.setState({ page: page }, () => this.filterData(this.state.filters));

  // LINHAS POR PÁGINA
  handleRowsPerPage = (size, page) => this.setState({ size: size, page: page }, () => this.filterData(this.state.filters));

  verifyOrderBy = (orderBy) => orderBy === 'dataCriacao' ? 'criacaoAuditInfo.dataCriacao' : orderBy;  
  // ORDENAÇÃO
  handleSort = (orderBy, order) => {
    orderBy = this.verifyOrderBy(orderBy);
    if (this.state.sort.find(s => s.orderBy === orderBy)) {
      let newSort = this.state.sort.filter(s => s.orderBy !== orderBy);
      newSort.splice(this.state.sort.indexOf(this.state.sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
      this.setState({ ...this.state, sort: [...newSort], filtered: true });
    } else {
      this.setState({ ...this.state, sort: [...this.state.sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }], filtered: true });
    }
  }
  handleClearSort = (orderBy) => {
    orderBy = this.verifyOrderBy(orderBy);
    this.setState({ ...this.state, filtered: true, sort: orderBy ? [...this.state.sort.filter(s => s.orderBy !== orderBy)] : [{ orderBy: this.state.defaultOrderBy, order: ASC }] });
  };

  // TOTAL DE PAGINAS
  handleTotalPages = () => this.state.totalPages;

  // TOTAL DE ELEMENTOS
  handleTotalElements = () => this.state.totalElements;

  // VERIFICAR PERSISTENCIA NO FORMULARIO DE FILTROS
  handleFilterPersistence = () => this.DocumentoFilter ? this.DocumentoFilter.state ? this.DocumentoFilter.handleFilterPersistence(this.state.filters) : null : null;

  componentDidMount() { this.loadData(); }

  carregarNome = (id) => {
    const documento = this.state.documentos.find(d => d.id === id);
    return patternNome(documento.candidato.nomeExibicao, documento.candidato.nomeSocial, documento.candidato.nome);
  }

  render() {
    const pageName = 'Documentos';
    const links = [
      {
        path: null,
        name: 'Administração'
      }
    ];

    const columns = [
      { label: '#', name: 'id', func: null, key: true, hidden: true },
      { label: 'Data de Envio', name: 'dataCriacao', func: null, key: false, filter: 'criacaoAuditInfo.dataCriacao' },
      { label: 'Código', name: 'candidato.codigo', func: null, key: false },
      { label: 'Candidato', name: 'candidato.nome', func: (value, id) => this.carregarNome(id), key: false },
      { label: 'Tipo de Documento', name: 'tipo.id', func: (value, id) => patternEnum(value, this.state.optionsTiposDocumento), key: false },
      { label: 'Status de Validação', name: 'validacao.status', func: (value, id) => patternEnum(value, this.state.optionsStatusValidacao), key: false },
      { label: 'Data de Validação', name: 'validacao.data', func: null, key: false, ordering: false },
      { label: 'Usuário que Validou', name: 'validacao.usuario', func: null, key: false, ordering: false },
    ];

    const actions = [
      {
        name: this.labelVer,
        func: this.handleVerClick,
        icon: <GetAppIcon />,
        disabled: () => !isAdministradorOuCentral(),
      },
      {
        name: this.labelTratar,
        func: this.handleTratarClick,
        icon: <AssignmentTurnedInIcon />,
        disabled: () => !isAdministradorOuCentral(),
      },
      {
        name: this.labelExcluir,
        func: this.handleExcluir,
        icon: <DeleteOutlinedIcon />,
        disabled: () => !isAdministradorOuCentral() || !isInscricoesAbertas(this.props.contexts),
        color: "secondary"
      },
    ];

    this.handleFilterPersistence();

    return (
      <Layout>
        <Toast parentRef={this.setToast} />
        <Grid container >
          <Grid item xs={12}>
            <Breadcrumbs links={links} active={pageName} />
          </Grid>
        </Grid>
        <Title>{pageName}</Title>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <DocumentoFilter
              parentRef={this.setDocumentoFilter}
              handleFilterChange={this.filterData}
            />
            <Table
              columns={columns}
              tableData={this.state.documentos}
              actions={actions}
              page={this.state.page}
              handlePage={this.handlePage}
              handleTotalPages={this.handleTotalPages}
              handleTotalElements={this.handleTotalElements}
              rowsPerPage={this.state.size}
              handleRowsPerPage={this.handleRowsPerPage}
              sort={this.state.sort}
              handleSort={this.handleSort}
              handleClearSort={this.handleClearSort}
              loading={this.state.loading}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <ButtonsTratamentoListaDocumentos
            onTratarFila={this.handleTratarFilaDocumentos}
            onLimparFila={this.handleLimparFilaTratamento}
            refreshFilaTratamento={this.state.refreshFilaTratamento}
            loadingFilaTratamento={this.state.loadingFilaTratamento}
            loadingLimparFilaTratamento={this.state.loadingLimparFilaTratamento}
          />
        </Grid>


        {isAdministradorOuCentral() &&
          <>
            <DialogTratamentoDocumento
              parentRef={this.setDialogTratamentoDocumento}
              handleConfirm={this.loadData}
              optionsStatusValidacao={this.state.optionsStatusValidacao}
            />

            <DialogTratamentoFilaDocumentos
              parentRef={this.setDialogTratamentoFilaDocumentos}
              handleConfirm={this.loadData}
              handleClose={this.loadData}
              loadingFilaTratamento={(value) => this.setState({ loadingFilaTratamento: value })}
            />

            <DialogRemoverDocumento
              parentRef={this.setDialogRemoverDocumento}
              handleConfirm={this.handleRemoverDocumentoConfirm}
            />
          </>
        }
      </Layout>
    )
  }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Documento));